const WEBSOCKET_STATE = {
    PENDING: "pending",
    OK: "ok",
    FAILED: "failed",
};

export { WEBSOCKET_STATE };